import React, { useEffect, useRef } from 'react'
import useGooglePlacesAutocomplete from '../../hook/useGooglePlacesAutocomplete';
const CreateDeliveryAddress = ({ handleCreateDeliveryAddress, setPickupFormData, pickupFormData, pickupFormErrors, handlePickupChange }) => {
    const inputRef = useRef(null);
    // const { initializeAutocomplete } = useGooglePlacesAutocomplete(pickupFormData, setPickupFormData, inputRef);
    useGooglePlacesAutocomplete(pickupFormData, setPickupFormData, inputRef);
    useEffect(() => {
        if (!window.google || !inputRef.current) return;

        const service = new window.google.maps.places.AutocompleteService();

        const handleInput = (e) => {
            const inputValue = e.target.value;
            if (inputValue.length > 2) {
                service.getPlacePredictions({ input: inputValue }, (predictions, status) => {
                    console.log("🔍 Autocomplete Predictions:", predictions, "Status:", status);
                });
            }
        };

        const inputEl = inputRef.current;
        inputEl.addEventListener("input", handleInput);

        return () => {
            inputEl.removeEventListener("input", handleInput);
        };
    }, []);

    return (
        <div
            className="modal fade"
            id="addDelivery"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"        >
            <div style={{ position: "relative" }} className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
                <div className="modal-content radius-16 bg-base">
                    <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">
                            Add Delivery Address

                        </h1>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        />
                    </div>
                    <div className="modal-body p-24">
                        <form onSubmit={handleCreateDeliveryAddress}>
                            <div className="row">

                                <div className="col-12 col-md-6 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Full Name
                                    </label>
                                    <input
                                        type="text"
                                        name="fullName"
                                        value={pickupFormData.fullName}
                                        onChange={handlePickupChange}
                                        className="form-control radius-8"
                                        placeholder="Enter Full Name"
                                        required

                                    />
                                    {pickupFormErrors.fullName && <small className="text-danger">{pickupFormErrors.fullName}</small>}
                                </div>

                                {/* Country Code */}
                                <div className="col-12 col-md-6 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Country Code
                                    </label>
                                    <select
                                        name="countryCode"
                                        value={pickupFormData.countryCode}
                                        onChange={handlePickupChange}
                                        className="form-control radius-8"
                                        required

                                    >
                                        <option value="">-- Select Country Code --</option>
                                        <option value="+91">+91 - India</option>
                                        <option value="+86">+86 - China</option>
                                        <option value="+1">+1 - Canada</option>
                                        <option value="+1-US">+1 - USA</option>
                                    </select>
                                    {pickupFormErrors.countryCode && <small className="text-danger">{pickupFormErrors.countryCode}</small>}
                                </div>

                                {/* Mobile Number */}
                                <div className="col-12 col-md-6 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Mobile Number
                                    </label>
                                    <input
                                        type="text"
                                        name="mobile"
                                        value={pickupFormData.mobile}
                                        onChange={handlePickupChange}
                                        required

                                        onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        maxLength={10}
                                        className="form-control radius-8"
                                        placeholder="Enter Mobile Number"
                                    />
                                    {pickupFormErrors.mobile && (
                                        <small className="text-danger">{pickupFormErrors.mobile}</small>
                                    )}

                                </div>

                                <div className="col-12 col-md-6 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Save As
                                    </label>
                                    <select
                                        name="saveAs"
                                        value={pickupFormData.saveAs}
                                        onChange={handlePickupChange}
                                        required

                                        className="form-control radius-8"
                                    >
                                        <option value="">-- Save As --</option>
                                        <option value="Home">Home</option>
                                        <option value="Work">Work</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    {pickupFormErrors.saveAs && <small className="text-danger">{pickupFormErrors.saveAs}</small>}
                                </div>






                                <div className="col-12 col-md-12 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Address Line 1
                                    </label>
                                    <input
                                        name="address"
                                        value={pickupFormData.address}
                                        onChange={handlePickupChange}
                                        className="form-control radius-8"
                                        autoComplete='off'
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") e.preventDefault(); // 👈 prevent submit if Enter is pressed
                                        }}

                                        ref={inputRef}

                                        placeholder="Enter Address"
                                        required

                                    />
                                    {pickupFormErrors.address && <small className="text-danger">{pickupFormErrors.address}</small>}
                                </div>



                                <div className="col-12 col-md-12 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Address Line 2 (Mannual)
                                    </label>
                                    <input
                                        type="text"
                                        name="addressLine2"
                                        value={pickupFormData.addressLine2}
                                        onChange={handlePickupChange}
                                        className="form-control radius-8"
                                        placeholder="Enter Address Line 2 "
                                        required

                                    />
                                    {pickupFormErrors.addressLine2 && <small className="text-danger">{pickupFormErrors.addressLine2}</small>}
                                </div>

                                <div className="col-12 col-md-4 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        State
                                    </label>
                                    <input
                                        type="text"
                                        name="state"
                                        value={pickupFormData.state}
                                        onChange={handlePickupChange}
                                        className="form-control radius-8"
                                        placeholder="Enter State"
                                        required

                                        onKeyPress={(e) => {
                                            if (/\d/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}

                                    />
                                    {pickupFormErrors.state && <small className="text-danger">{pickupFormErrors.state}</small>}
                                </div>
                                <div className="col-12 col-md-4 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        City
                                    </label>
                                    <input
                                        type="text"
                                        name="city"
                                        value={pickupFormData.city}
                                        onChange={handlePickupChange}
                                        className="form-control radius-8"
                                        required

                                        placeholder="Enter City"
                                        onKeyPress={(e) => {
                                            if (/\d/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}

                                    />
                                    {pickupFormErrors.city && <small className="text-danger">{pickupFormErrors.city}</small>}
                                </div>

                                {/* Zip Code */}
                                <div className="col-12 col-md-4 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Postal Code
                                    </label>
                                    <input
                                        type="text"
                                        name="zipCode"
                                        value={pickupFormData.zipCode}
                                        onChange={handlePickupChange}
                                        className="form-control radius-8"
                                        required

                                        placeholder="Enter Postal Code"
                                    />
                                    {pickupFormErrors.zipCode && <small className="text-danger">{pickupFormErrors.zipCode}</small>}
                                </div>

                                {/* Address */}





                                {/* <div className="col-12 col-md-4 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Area Name
                                    </label>
                                    <input
                                        name="areaName"
                                        value={pickupFormData.areaName}
                                        onChange={handlePickupChange}
                                        className="form-control radius-8"
                                        placeholder="Enter Area Name"
                                        required
                                        type="text"


                                    />
                                    {pickupFormErrors.areaName && <small className="text-danger">{pickupFormErrors.areaName}</small>}
                                </div> */}




                                {/* Landmark */}
                                {/* <div className="col-12 col-md-4 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Landmark
                                    </label>
                                    <input
                                        type="text"
                                        name="landmark"
                                        value={pickupFormData.landmark}
                                        onChange={handlePickupChange}
                                        className="form-control radius-8"
                                        required

                                        placeholder="Enter Landmark"
                                    />
                                    {pickupFormErrors.landmark && <small className="text-danger">{pickupFormErrors.landmark}</small>}
                                </div> */}

                                {/* <div className="col-12 col-md-4 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Apartment/Building No.
                                    </label>
                                    <input
                                        type="text"
                                        name="buildingNo"
                                        value={pickupFormData.buildingNo}
                                        onChange={handlePickupChange}
                                        className="form-control radius-8"
                                        required

                                        placeholder="Enter Building No."
                                    />
                                    {pickupFormErrors.buildingNo && <small className="text-danger">{pickupFormErrors.buildingNo}</small>}
                                </div> */}

                                {/* Save As */}

                                {/* Submit Button */}
                                <div className="d-flex align-items-center justify-content-start gap-3 mt-12">
                                    <button
                                        type="submit"
                                        className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>


                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateDeliveryAddress
